import { render, staticRenderFns } from "./RequestHistoryModal.vue?vue&type=template&id=53a73b9f&"
import script from "./RequestHistoryModal.vue?vue&type=script&lang=js&"
export * from "./RequestHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports